import "core-js/modules/es.array.map.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * module deliveryRegistration
 * author xuyuxiong
 * description 交房登记
 */
import { fetchList } from '@/api/PMS/houseDeliveryManage/deliveryRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import deliveryAdd from './add';
import houseDetail from '@/views/PMS/baseInformation/WuyeZiyuanManager/house/detail';
import customerDetail from '@/views/PMS/baseInformation/customer/detail';
export default {
  components: {
    deliveryAdd: deliveryAdd,
    houseDetail: houseDetail,
    customerDetail: customerDetail
  },
  data: function data() {
    return {
      customerId: '',
      houseId: '',
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      downloadLoading: false,
      dialogHouseFormVisible: false,
      dialogCustomerFormVisible: false,
      listQuery: {
        limit: 10,
        page: 1,
        houseStatus: 1
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      total: 0,
      title: '',
      deliveryData: {},
      cascaderItem: [],
      floorOption: [],
      buildingOptions: [],
      dates: [],
      multipleSelection: []
    };
  },
  watch: {
    propertyObj: {
      handler: function handler(n, o) {
        this.getList();
      },
      immediate: true
    }
  },
  created: function created() {
    this.cascaderItem = [];
    this.floorOption = [];
    this.buildingOptions = [];
    this.getList();
    this.loadBuiildingTree();
  },
  methods: {
    loadBuiildingTree: function loadBuiildingTree() {
      var _this = this;

      var treeQuery = {
        flag: 2
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.buildingOptions = response.data.data;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList: function getList() {
      var _this2 = this;

      fetchList(this.listQuery).then(function (res) {
        _this2.list = res.data.data;
        _this2.total = res.data.total;
      });
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this3 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this3.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    checkSelectBuild: function checkSelectBuild(val) {
      if (val) {
        this.listQuery.buildingId = '';
        this.cascaderItem = [];
        this.getCascaderItem(this.listQuery.upIdList, this.buildingOptions);

        if (this.cascaderItem.length > 0 && this.cascaderItem[this.cascaderItem.length - 1].flag !== '2') {
          this.$message({
            message: '请选择正确的楼栋',
            type: 'error',
            duration: 3000
          });
          this.listQuery.upIdList = [];
        }

        this.listQuery.buildingId = this.listQuery.upIdList[this.listQuery.upIdList.length - 1];
      }
    },
    handleFilter: function handleFilter() {
      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      this.getList();
    },
    deliveryRegistration: function deliveryRegistration() {
      this.deliveryData = {};
      this.dialogFormVisible = true;
      this.title = '交房登记';
    },
    handleUpdate: function handleUpdate(obj) {
      this.dialogFormVisible = true;
      this.deliveryData = {
        id: obj.id,
        houseId: obj.houseId,
        customerId: obj.customerId,
        customerName: obj.customerName,
        houseCode: obj.houseCode,
        statusDate: obj.statusDate
      };
      this.title = '更改交房日期';
    },
    getRoomDetail: function getRoomDetail(houseId) {
      this.dialogHouseFormVisible = true;
      this.houseId = houseId;
      this.title = '详情';
    },
    getCustomerDetail: function getCustomerDetail(customerId) {
      this.dialogCustomerFormVisible = true;
      this.customerId = customerId;
      this.title = '详情';
    },
    handCancle: function handCancle() {
      this.getList();
      this.dialogFormVisible = false;
      this.dialogHouseFormVisible = false;
      this.dialogCustomerFormVisible = false;
    }
  }
};